export default "./dist/stdassets/images/icons/invoke-script.png";